<template>
<AppLayout>
  <div class="inventory">
    <section id="suppliers-add" class="filter-search">
      <div class="container">
          <p class="mt-2 fw-bold">1. Add Details</p>
          <div>
            <div class="form">
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-name">Supplier Name</label>
                    <input type="text" class="form-control" id="product-name" v-model="name">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-name">VAT Number</label>
                    <input type="text" class="form-control" id="product-name" v-model="idNumber">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Business Description</label>
                    <input type="text" class="form-control" id="item-code" v-model="natureBusiness">
                  </div>
                </div>
               
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="address">Office Address</label>
                    <input type="text" v-model="address" id="address" class="form-control">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Supplier Contact Person</label>
                    <input type="text" class="form-control" id="item-code" v-model="contact">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Mobile No.</label>
                    <input 
                      type="tel" 
                      class="form-control" 
                      id="item-code" 
                      v-model="phone"
                      :class="{ 'is-invalid': phone && !isValidPhoneNumber(phone) }"
                      @blur="validatePhone"
                    >
                    <small v-if="phone && !isValidPhoneNumber(phone)" class="text-danger">
                      ⚠️ Format: +254 followed by 9 digits (e.g., +254702034090)
                    </small>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Mobile No. 2 (optional)</label>
                    <input 
                      type="tel" 
                      class="form-control" 
                      id="item-code" 
                      v-model="phone2"
                      :class="{ 'is-invalid': phone2 && !isValidPhoneNumber(phone2) }"
                      @blur="validatePhone"
                    >
                    <small v-if="phone2 && !isValidPhoneNumber(phone2)" class="text-danger">
                      ⚠️ Format: +254 followed by 9 digits (e.g., +254702034090)
                    </small>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Email</label>
                    <input 
                      type="email" 
                      class="form-control" 
                      id="item-code" 
                      v-model="email"
                      @blur="validateEmail"
                    >
                    <!--<small v-if="email" class="text-danger">
                      ⚠️ Please use a company email (not Gmail, Yahoo, Hotmail, etc.)
                    </small>-->
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="item-code">Email 2 (optional)</label>
                    <input 
                      type="email" 
                      class="form-control" 
                      id="item-code" 
                      v-model="email2"
                      @blur="validateEmail"
                    >
                    <!--<small v-if="email2 && !isCompanyEmail(email2)" class="text-danger">
                      ⚠️ Please use a company email (not Gmail, Yahoo, Hotmail, etc.)
                    </small>-->
                  </div>
                </div>

                <!--
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-picture">ID Front</label>
                    <input type="file" class="form-control" id="id-font" ref="idFront" @change="handleIDChange">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="product-picture">ID Back</label>
                      <input type="file" class="form-control" id="id-back" ref="idBack" @change="handleIDChange">
                  </div>
                </div>-->
                
                <div class="col-md-2" v-if="loading">
                  <div style="margin-top: 40px"> 
                    processing ID
                    <img  src="../../assets/images/loader.gif"/> 
                  </div>
                </div>

                <div class="col-md-2">
                    <div class="check-button">
                    <div class="form-group">
                        <label>Pre-qualified</label>
                        <div class="components-button">
                    <span class="switcher switcher-1">
                        <input type="checkbox" id="switcher-1" v-model="qualified" :disabled="!allMandatoryCovered">
                        <label for="switcher-1"></label>
                    </span>
                        </div>
                        <small v-if="!allMandatoryCovered" class="text-danger" style="font-size:11px">Upload all mandatory docs first</small>
                    </div>
                    </div>
                </div>


                 <div class="col-md-2">
                  <div class="form-group">
                    <label for="procurement-categories">Procurement Categories</label>
                    <multiselect v-model="selectedTenderCategoryObjects"
                      :options="tenderCategories"
                      :multiple="true"
                      track-by="id"
                      label="name"
                      placeholder="Select procurement categories"
                      class="form-control"
                    />
                  </div>
                </div>

                
              </div>
  
            </div>
          </div>
          <!-- Documents section -->
          <div>
            <p class="fw-bold">2. Add Documents</p>
            <table class="table table-hover">
              <thead>
                <th>No.</th>
                <th>Document Name</th>
                <th style="min-width: 260px">Document Type</th>
                <th>Renewal/Expiry Date</th>
                <th>Upload Document</th>
                <th>Action</th>
              </thead>
              <tbody>
                <tr v-for="(doc, index) in pendingDocuments" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td><input type="text" placeholder="Enter name" class="form-control" v-model="doc.name"></td>
                  <td>
                    <!-- Custom dropdown per row -->
                    <div class="doc-type-dropdown" :class="{ open: doc.dropdownOpen }" :ref="'docDropdown_' + index">
                      <div class="doc-type-selected" @click="doc.dropdownOpen = !doc.dropdownOpen">
                        <span v-if="!doc.supplierDocumentTypeId" class="placeholder-text">Select type</span>
                        <template v-else>
                          <span>{{ supplierDocumentTypes.find(t => t.id == doc.supplierDocumentTypeId)?.name }}</span>
                          <span class="badge-suffix" :class="supplierDocumentTypes.find(t => t.id == doc.supplierDocumentTypeId)?.isMandatory ? 'badge-mandatory' : 'badge-optional'">
                            - {{ supplierDocumentTypes.find(t => t.id == doc.supplierDocumentTypeId)?.isMandatory ? 'Mandatory' : 'Not Mandatory' }}
                          </span>
                        </template>
                        <span class="doc-type-caret">&#9660;</span>
                      </div>
                      <ul class="doc-type-list" v-show="doc.dropdownOpen">
                        <li @click="doc.supplierDocumentTypeId = null; doc.dropdownOpen = false" :class="{ active: !doc.supplierDocumentTypeId }">
                          <span class="placeholder-text">Select type</span>
                        </li>
                        <li v-for="t in sortedSupplierDocumentTypes" :key="t.id"
                          @click="doc.supplierDocumentTypeId = t.id; doc.dropdownOpen = false"
                          :class="{ active: doc.supplierDocumentTypeId == t.id }">
                          <span>{{ t.name }}</span>
                          <span class="badge-suffix" :class="t.isMandatory ? 'badge-mandatory' : 'badge-optional'">
                            - {{ t.isMandatory ? 'Mandatory' : 'Not Mandatory' }}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td><input type="date" class="form-control" v-model="doc.expiry"></td>
                  <td>
                    <input type="file" class="form-control" @change="handleDocFileChange($event, index)">
                    <small v-if="doc.file" class="text-success" style="font-size:11px">✔ {{ doc.file.name }}</small>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-danger" @click="removeDocumentRow(index)" :disabled="pendingDocuments.length === 1">✕</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button class="btn btn-sm btn-outline-secondary mb-3" @click="addDocumentRow">+ Add Row</button>
          </div>

          <!-- Single submit button -->
          <div class="mt-2 mb-4">
            <button class="btn-style small" @click="submitAll" :disabled="isPosting">
              <span v-if="isPosting">Saving... <img src="../../assets/images/loader.gif" style="width:20px;margin-left:5px"/></span>
              <span v-else>Add Supplier</span>
            </button>
          </div>

      </div><!-- /container -->
    </section>
  </div><!-- /inventory -->
</AppLayout>
          
  </template>
  
  <script>
  import Swal from 'sweetalert2'
  import AppLayout from '../../components/AppLayout.vue';
  import Multiselect from 'vue-multiselect';
  
  export default {
    name: 'AddSupplierPage',
    components: {
      AppLayout,
      Multiselect
    },
    data: () => ({
      token: JSON.parse(localStorage.getItem('access_token')),
      urlServer: process.env.VUE_APP_URL,
      tenderCategories: [],
      selectedTenderCategoryIds: [],
      selectedTenderCategoryObjects: [],
      name: "",
      natureBusiness: "",
      address: "",
      contact: "",
      phone: "+254",
      phone2: "",
      idNumber: "",
      email: "",
      email2: "",
      qualified: false,
      supplierDocumentTypes: [],
      pendingDocuments: [
        { name: '', supplierDocumentTypeId: null, expiry: '', file: null, dropdownOpen: false }
      ],
      isPosting: false
    }),
    async created() {
      await this.loadTenderCategories()
      await this.loadSupplierDocumentTypes()
    },
    mounted() {
      this._closeDropdowns = (e) => {
        this.pendingDocuments.forEach((doc, i) => {
          const ref = this.$refs['docDropdown_' + i]
          const el = Array.isArray(ref) ? ref[0] : ref
          if (el && !el.contains(e.target)) doc.dropdownOpen = false
        })
      }
      window.addEventListener('click', this._closeDropdowns)
    },
    beforeUnmount() {
      window.removeEventListener('click', this._closeDropdowns)
    },
    computed: {
      sortedSupplierDocumentTypes() {
        return [...(this.supplierDocumentTypes || [])].sort((a, b) => {
          if (a.isMandatory === b.isMandatory) return (a.name || '').localeCompare(b.name || '')
          return a.isMandatory ? -1 : 1
        })
      },
      mandatoryTypes() {
        return (this.supplierDocumentTypes || []).filter(t => t.isMandatory)
      },
      allMandatoryCovered() {
        if (this.mandatoryTypes.length === 0) return true
        const coveredIds = new Set(
          this.pendingDocuments
            .filter(d => d.supplierDocumentTypeId && d.file)
            .map(d => Number(d.supplierDocumentTypeId))
        )
        return this.mandatoryTypes.every(t => coveredIds.has(Number(t.id)))
      }
    },
    methods:{
        isValidPhoneNumber(number) {
            const regex = /^\+254\d{9}$/;
            return regex.test(number);
        },
        isCompanyEmail(email) {
            if (!email) return false;
            const personalDomains = [
                'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com',
                'mail.com', 'protonmail.com', 'icloud.com', 'ymail.com', 'rocketmail.com',
                'gmx.com', 'zoho.com', 'tutanota.com', 'mailbox.org', 'fastmail.com',
                'temp-mail.org', '10minutemail.com', 'guerrillamail.com', 'mailinator.com'
            ];
            const emailDomain = email.toLowerCase().split('@')[1];
            return !personalDomains.includes(emailDomain);
        },
        validateEmail() { return true },
        validatePhone() { return true },

        addDocumentRow() {
          this.pendingDocuments.push({ name: '', supplierDocumentTypeId: null, expiry: '', file: null, dropdownOpen: false })
        },
        removeDocumentRow(index) {
          if (this.pendingDocuments.length > 1) this.pendingDocuments.splice(index, 1)
        },
        handleDocFileChange(event, index) {
          const file = event.target.files[0] || null
          this.pendingDocuments[index].file = file
          // Re-evaluate prequalified status reactively
          this.$forceUpdate()
          if (this.allMandatoryCovered) this.qualified = true
        },

        async loadTenderCategories() {
          try {
            const res = await fetch(process.env.VUE_APP_URL + '/tender-category', {
              headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token }
            })
            if (!res.ok) return
            const data = await res.json()
            this.tenderCategories = Array.isArray(data) ? data : (data.data || [])
            if (this.selectedTenderCategoryIds && this.selectedTenderCategoryIds.length) {
              this.selectedTenderCategoryObjects = this.tenderCategories.filter(cat => this.selectedTenderCategoryIds.includes(cat.id))
            }
          } catch (e) {
            console.error('Failed to load Procurement Categories', e)
          }
        },
        async loadSupplierDocumentTypes() {
          try {
            const res = await fetch(process.env.VUE_APP_URL + '/supplier-document-type', {
              headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token }
            })
            if (!res.ok) return
            const data = await res.json()
            this.supplierDocumentTypes = Array.isArray(data) ? data : (data.data || [])
          } catch (e) {
            console.error('Failed to load supplier document types', e)
          }
        },

        formatDate(date) {
          if (!date) return ''
          try { return new Date(date).toLocaleDateString() } catch (e) { return date }
        },

        async submitAll() {
          // --- Validate supplier fields ---
          if (!this.isValidPhoneNumber(this.phone)) {
            Swal.fire({ icon: 'error', title: 'Invalid phone number', text: 'Expected format +254.... 13 characters' })
            return
          }
          if (this.phone2 && !this.isValidPhoneNumber(this.phone2)) {
            Swal.fire({ icon: 'error', title: 'Invalid secondary phone', text: 'Expected format +254.... 13 characters' })
            return
          }
          if (!this.email) {
            Swal.fire({ icon: 'error', title: 'Email required', text: 'Please provide a company email address' })
            return
          }
          // --- Validate mandatory docs ---
          if (!this.allMandatoryCovered) {
            const missing = this.mandatoryTypes
              .filter(t => !this.pendingDocuments.some(d => Number(d.supplierDocumentTypeId) === Number(t.id) && d.file))
              .map(t => t.name).join(', ')
            Swal.fire({ icon: 'warning', title: 'Missing mandatory documents', text: `Please upload: ${missing}` })
            return
          }

          this.isPosting = true
          try {
            // Step 1: Create supplier
            const supplierRes = await fetch(process.env.VUE_APP_URL + '/suppliers', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
              body: JSON.stringify({
                name: this.name,
                business: this.natureBusiness,
                address: this.address,
                idNumber: this.idNumber,
                contact: this.contact,
                phone: this.phone,
                email: this.email,
                phone2: this.phone2 || undefined,
                email2: this.email2 || undefined,
                prequalified: this.qualified,
                tenderCategoryIds: this.selectedTenderCategoryObjects.map(c => c.id),
              })
            })
            const supplierData = await supplierRes.json()
            if (!supplierData.status) {
              Swal.fire({ icon: 'error', title: 'Supplier not created', text: supplierData.message })
              return
            }
            const supplierId = supplierData.supplier.id

            // Step 2: Upload all documents in parallel
            const docsWithFiles = this.pendingDocuments.filter(d => d.file)
            await Promise.all(docsWithFiles.map(doc => {
              const fd = new FormData()
              fd.append('name', doc.name || '')
              fd.append('expiry', doc.expiry || '')
              fd.append('supplierId', supplierId)
              if (doc.supplierDocumentTypeId) fd.append('supplierDocumentTypeId', doc.supplierDocumentTypeId)
              fd.append('file', doc.file)
              return fetch(process.env.VUE_APP_URL + '/suppliers/document', {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + this.token },
                body: fd
              })
            }))

            Swal.fire({ icon: 'success', title: 'Supplier created successfully', showConfirmButton: false, timer: 1800 })
            // Reset form
            this.name = ''; this.natureBusiness = ''; this.address = ''; this.contact = ''
            this.phone = '+254'; this.phone2 = ''; this.idNumber = ''; this.email = ''; this.email2 = ''
            this.qualified = false; this.selectedTenderCategoryObjects = []
            this.pendingDocuments = [{ name: '', supplierDocumentTypeId: null, expiry: '', file: null, dropdownOpen: false }]
          } catch (err) {
            Swal.fire({ icon: 'error', title: 'Error', text: err.message || 'An error occurred' })
          } finally {
            this.isPosting = false
          }
        },
    }
  }
  </script>

  <style lang="scss" scoped>

@import 'vue-multiselect/dist/vue-multiselect.min.css';

$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;
  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 13px;
                font-weight: 600;
                font-size: 13px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 13px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                    height: 30px !important;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    height: 30px !important;
                    background: $green;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                  }
                }
              }
            }
          }
        }
    }

    .input-file{
      border-radius: 3px!important;
      height: 38px;
      display: flex; 
      align-items: center;
      padding-top: 8px !important;
      padding-left: 4px  !important;
      background: $white!important;
      border: 1px solid #b4c7e7 !important;
      color: black;
      &::placeholder{
        color: black;
        font-size: 13px;
        font-weight: 500;
        line-height: 22px;
        text-transform: capitalize;
      }
      &:focus{
        box-shadow: none;
      }
}

.multiselect__tag {
    background: linear-gradient(90deg, #2B286C 0%, #2B286C 100%) !important;
    color: white;
    border-radius: 4px;
    padding: 5px 10px;
    margin: 2px;
}

.multiselect__tag:hover {
  background: linear-gradient(90deg, #20203f 0%, #20203f 100%) !important;
}

/* Optional: use this class on the multiselect to switch tags to brand color */
.multiselect--brand-orange .multiselect__tag {
  background: linear-gradient(90deg, #2B286C 0%, #2B286C 100%) !important;
}
.multiselect--brand-orange .multiselect__tag:hover {
  background: linear-gradient(90deg, #20203f 0%, #20203f 100%) !important;
}

.multiselect__tag .multiselect__tag-icon {
  color: white; 
}

/* Increase multiselect width and height for better usability */
.multiselect {
  width: 100% !important;
  min-height: 44px;
  box-sizing: border-box;
}
.multiselect .multiselect__tags {
  min-height: 44px;
  align-items: center;
}
.multiselect .multiselect__input,
.multiselect .multiselect__single {
  height: 40px !important;
  line-height: 40px !important;
}
.multiselect .multiselect__placeholder {
  line-height: 40px;
}
.multiselect .multiselect__select {
  height: 40px;
}

/* Email validation styles */
.form-control.is-invalid {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.text-danger {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

/* Custom document-type dropdown */
.doc-type-dropdown {
  position: relative;
  width: 100%;
  min-width: 260px;
  font-size: 14px;
}
.doc-type-selected {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  min-height: 38px;
  user-select: none;
}
.doc-type-selected:hover {
  border-color: #86b7fe;
}
.doc-type-caret {
  margin-left: auto;
  font-size: 10px;
  color: #6c757d;
}
.doc-type-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1050;
  list-style: none;
  margin: 2px 0 0;
  padding: 4px 0;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,.12);
  max-height: 220px;
  overflow-y: auto;
}
.doc-type-list li {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  cursor: pointer;
}
.doc-type-list li:hover,
.doc-type-list li.active {
  background: #f0f4ff;
}
.placeholder-text {
  color: #6c757d;
}
.badge-suffix {
  font-size: 12px;
}
.badge-mandatory {
  color: #198754;
}
.badge-optional {
  color: #dc3545;
}

  </style>